export const LogoMark = ({ className = "w-8 h-8", stroke = "currentColor" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <path d="M24 9 L11 42" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M24 9 L37 42" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M12.5 31 C19 23.5 29 23 36.5 27.5 C29.5 32.5 19.5 33.5 12.5 31 Z" fill="#68735B" />
    <path d="M12.5 31 C21 28.5 28 27.8 36.5 27.5" stroke="#FAF7F2" strokeWidth="0.8" strokeLinecap="round" />
    <circle cx="24" cy="6" r="2.4" fill="#9AA984" />
  </svg>
);

export const Logo = () => (
  <img src="/img/logo.png" alt="Annette · Botanical · Home · Wedding & Event" className="h-11 sm:h-12 w-auto" />
);
